import Icon from "@/ui/core/Icon";
import { FAIconName } from "@/ui/core/Icon/IconDefinitions";
import { Box } from "@/ui/layout";
import { ColorToken, OpacityToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

type NavigationButtonType = "back" | "close";

interface NavigationIconButtonProps extends BaseViewProps {
  onPress: () => void;
  type: NavigationButtonType;
}

const IconTypeMapper: Record<NavigationButtonType, FAIconName> = {
  back: FAIconName.ChevronLeft,
  close: FAIconName.Times,
};

const NavigationIconButton = ({
  accessibilityLabel,
  onPress,
  testID,
  type,
}: NavigationIconButtonProps) => {
  const baseTestID = joinTestIDs(testID, "nav");

  return (
    <Box
      accessibilityLabel={accessibilityLabel}
      alignItems="center"
      backgroundColor={ColorToken.Transparent}
      height={32}
      justifyContent="center"
      onPress={onPress}
      pressStyle={{
        opacity: OpacityToken.Pressed,
      }}
      role="navigation"
      testID={baseTestID}
      width={32}
    >
      <Icon
        color={ColorToken.NeutralPrimary}
        name={IconTypeMapper[type]}
        size="lg"
        testID={baseTestID}
      />
    </Box>
  );
};

export default NavigationIconButton;

export type { NavigationButtonType, NavigationIconButtonProps };
